import React, { useMemo } from 'react';
import cn from '@/utils/cn';

type SortingCaretProps = {
  isSorted: boolean;
  order: string;
};

const CARET_CLASS_NAME = 'tw-ml-2';

const SortingCaret = ({ isSorted, order }: SortingCaretProps) => {
  const iconClassName = useMemo(() => {
    if (!isSorted) return 'fa fa-sort';
    if (order === 'asc') return 'fa fa-sort-asc';

    return 'fa fa-sort-desc';
  }, [isSorted, order]);

  return (
    <span className={cn(CARET_CLASS_NAME)}>
      <i aria-hidden="true" className={iconClassName} />
    </span>
  );
};

export default SortingCaret;
